export const sharingConnectorsCopy = {
  en: {
    statusConnected: 'Connected',
    statusNotConnected: 'Not connected',
    statusNotConfigured: 'Not available yet',
    statusNeedsReauthorization: 'Needs sign-in',
    statusUnavailable: 'Unavailable',
    statusDisabled: 'Turned off',
    audienceEveryone: 'Everyone at {company}',
    audienceSelected: 'Selected colleagues',
    audienceOnlyMe: 'Only me',
    companyPublish:
      'You can publish to the company. Everyone in the organisation will be able to read this item.',
    companyApproval:
      'This exact version will be sent for approval. Everyone will gain access only after it is approved.',
    companyInstant: 'Everyone at {company} can read this as soon as you save.',
    connectionPlan:
      'Pipedream connections cannot run tools in production on this workspace’s current plan. An admin needs to enable Pipedream Connect before anyone connects an account. Existing account authorizations are preserved.',
    connectionUnavailable:
      'The connection service is unavailable right now. Try again later or ask a workspace admin to check it. Existing account authorizations are preserved.',
    readyMetaNoAccounts:
      'Meta is connected, but this account has no accessible ad accounts. Ask a Meta admin to grant access to an ad account, then reconnect.',
    readyPermissions:
      'Meta is connected, but the required Ads permissions are not available. Review the requested permissions and reconnect, or ask the workspace admin to complete Meta app review.',
    readyAuth: 'Meta needs you to sign in again before its Ads data can be read.',
    readyRate: 'Meta temporarily limited requests for this connection. Try again later.',
    readyNoTools: 'Meta is connected, but it did not provide any tools for this account.',
    readyToolsAuth: 'Meta needs you to sign in again before its tools can be used.',
    readyUnavailable:
      'Meta tools are temporarily unavailable. Try checking the connection again later.',
    readyCheck: 'Meta could not be checked right now. Try checking the connection again later.',
    readyEmpty: 'Meta is connected, but there is no accessible data yet.',
    readyDefault:
      'Meta is connected, but its available tools could not be checked. Try again later.',
    completed: '{name} is connected.',
    snapshotChanged: 'This conversation changed. Refresh the preview before saving.',
    snapshotTooLarge:
      'This conversation is too long for one copy. Ask Poneva to save a summary as a Result instead.',
    snapshotEmpty: 'There are no saved messages to share yet.',
    snapshotGeneric: 'We could not prepare this copy. Please try again.',
  },
  bg: {
    statusConnected: 'Свързан',
    statusNotConnected: 'Не е свързан',
    statusNotConfigured: 'Все още не е наличен',
    statusNeedsReauthorization: 'Изисква повторно влизане',
    statusUnavailable: 'Недостъпен',
    statusDisabled: 'Изключен',
    audienceEveryone: 'Всички в {company}',
    audienceSelected: 'Избрани колеги',
    audienceOnlyMe: 'Само аз',
    companyPublish:
      'Можете да публикувате за компанията. Всеки в организацията ще може да прочете този елемент.',
    companyApproval:
      'Тази точна версия ще бъде изпратена за одобрение. Всеки ще получи достъп едва след като бъде одобрена.',
    companyInstant: 'Всички в {company} ще могат да прочетат това веднага след като го запазите.',
    connectionPlan:
      'Връзките с Pipedream не могат да изпълняват инструменти в продукционна среда с текущия план на това работно пространство. Администратор трябва да активира Pipedream Connect, преди някой да свърже акаунт. Съществуващите оторизации на акаунти се запазват.',
    connectionUnavailable:
      'Услугата за връзки в момента не е достъпна. Опитайте отново по-късно или помолете администратор на работното пространство да я провери. Съществуващите оторизации на акаунти се запазват.',
    readyMetaNoAccounts:
      'Meta е свързана, но този акаунт няма достъпни рекламни акаунти. Помолете администратор на Meta да предостави достъп до рекламен акаунт, след което се свържете отново.',
    readyPermissions:
      'Meta е свързана, но необходимите разрешения за реклами не са налични. Прегледайте заявените разрешения и се свържете отново или помолете администратора на работното пространство да завърши прегледа на приложението в Meta.',
    readyAuth:
      'Meta изисква да влезете отново, преди данните за реклами да могат да бъдат прочетени.',
    readyRate: 'Meta временно ограничи заявките за тази връзка. Опитайте отново по-късно.',
    readyNoTools: 'Meta е свързана, но не предостави инструменти за този акаунт.',
    readyToolsAuth:
      'Meta изисква да влезете отново, преди инструментите ѝ да могат да се използват.',
    readyUnavailable:
      'Инструментите на Meta временно не са достъпни. Опитайте да проверите връзката отново по-късно.',
    readyCheck:
      'В момента Meta не може да бъде проверена. Опитайте да проверите връзката отново по-късно.',
    readyEmpty: 'Meta е свързана, но все още няма достъпни данни.',
    readyDefault:
      'Meta е свързана, но наличните ѝ инструменти не могат да бъдат проверени. Опитайте отново по-късно.',
    completed: '{name} е свързан.',
    snapshotChanged: 'Този разговор се промени. Обновете визуализацията, преди да го запазите.',
    snapshotTooLarge:
      'Този разговор е твърде дълъг за едно копие. Помолете Poneva да запази обобщение като резултат.',
    snapshotEmpty: 'Все още няма запазени съобщения за споделяне.',
    snapshotGeneric: 'Не успяхме да подготвим това копие. Опитайте отново.',
  },
  hr: {
    statusConnected: 'Povezano',
    statusNotConnected: 'Nije povezano',
    statusNotConfigured: 'Još nije dostupno',
    statusNeedsReauthorization: 'Potrebna je ponovna prijava',
    statusUnavailable: 'Nedostupno',
    statusDisabled: 'Isključeno',
    audienceEveryone: 'Svi u tvrtki {company}',
    audienceSelected: 'Odabrani kolege',
    audienceOnlyMe: 'Samo ja',
    companyPublish:
      'Možete objaviti sadržaj za tvrtku. Svi u organizaciji moći će pročitati ovu stavku.',
    companyApproval:
      'Ova će se točna verzija poslati na odobrenje. Svi će dobiti pristup tek nakon odobrenja.',
    companyInstant: 'Svi u tvrtki {company} moći će ovo pročitati čim spremite.',
    connectionPlan:
      'Pipedream veze ne mogu pokretati alate u produkciji na trenutačnom planu ovog radnog prostora. Administrator mora omogućiti Pipedream Connect prije nego što itko poveže račun. Postojeća odobrenja računa ostaju sačuvana.',
    connectionUnavailable:
      'Usluga povezivanja trenutačno nije dostupna. Pokušajte ponovno kasnije ili zamolite administratora radnog prostora da to provjeri. Postojeća odobrenja računa ostaju sačuvana.',
    readyMetaNoAccounts:
      'Meta je povezana, ali ovaj račun nema dostupne oglašivačke račune. Zamolite Meta administratora da vam odobri pristup oglašivačkom računu, a zatim se ponovno povežite.',
    readyPermissions:
      'Meta je povezana, ali potrebna dopuštenja za oglase nisu dostupna. Pregledajte zatražena dopuštenja i ponovno se povežite ili zamolite administratora radnog prostora da dovrši provjeru Meta aplikacije.',
    readyAuth: 'Meta zahtijeva ponovnu prijavu prije nego što se mogu čitati podaci o oglasima.',
    readyRate: 'Meta je privremeno ograničila zahtjeve za ovu vezu. Pokušajte ponovno kasnije.',
    readyNoTools: 'Meta je povezana, ali za ovaj račun nije omogućila nijedan alat.',
    readyToolsAuth:
      'Meta zahtijeva ponovnu prijavu prije nego što se njezini alati mogu upotrebljavati.',
    readyUnavailable:
      'Metini alati privremeno nisu dostupni. Pokušajte ponovno provjeriti vezu kasnije.',
    readyCheck:
      'Metu trenutačno nije moguće provjeriti. Pokušajte ponovno provjeriti vezu kasnije.',
    readyEmpty: 'Meta je povezana, ali još nema dostupnih podataka.',
    readyDefault:
      'Meta je povezana, ali nije moguće provjeriti njezine dostupne alate. Pokušajte ponovno kasnije.',
    completed: '{name} je povezan.',
    snapshotChanged: 'Ovaj se razgovor promijenio. Osvježite pretpregled prije spremanja.',
    snapshotTooLarge:
      'Ovaj je razgovor predug za jedno kopiranje. Zatražite od Poneve da sačuva sažetak kao rezultat.',
    snapshotEmpty: 'Još nema spremljenih poruka za dijeljenje.',
    snapshotGeneric: 'Nismo mogli pripremiti ovu kopiju. Pokušajte ponovno.',
  },
  cs: {
    statusConnected: 'Připojeno',
    statusNotConnected: 'Nepřipojeno',
    statusNotConfigured: 'Zatím není k dispozici',
    statusNeedsReauthorization: 'Vyžaduje přihlášení',
    statusUnavailable: 'Nedostupné',
    statusDisabled: 'Vypnuto',
    audienceEveryone: 'Všichni ve společnosti {company}',
    audienceSelected: 'Vybraní kolegové',
    audienceOnlyMe: 'Jen já',
    companyPublish:
      'Můžete publikovat pro celou společnost. Tuto položku si bude moci přečíst každý v organizaci.',
    companyApproval:
      'Tato přesná verze bude odeslána ke schválení. Přístup získají všichni až po jejím schválení.',
    companyInstant: 'Všichni ve společnosti {company} si to mohou přečíst hned po uložení.',
    connectionPlan:
      'Připojení Pipedream nemohou v tomto pracovním prostoru v rámci aktuálního tarifu spouštět nástroje v produkčním prostředí. Správce musí povolit Pipedream Connect, než kdokoli připojí účet. Stávající autorizace účtů zůstanou zachovány.',
    connectionUnavailable:
      'Služba připojení je momentálně nedostupná. Zkuste to znovu později nebo požádejte správce pracovního prostoru, aby ji zkontroloval. Stávající autorizace účtů zůstanou zachovány.',
    readyMetaNoAccounts:
      'Meta je připojena, ale tento účet nemá přístup k žádným reklamním účtům. Požádejte správce Meta o udělení přístupu k reklamnímu účtu a poté se znovu připojte.',
    readyPermissions:
      'Meta je připojena, ale požadovaná oprávnění k reklamám nejsou k dispozici. Zkontrolujte požadovaná oprávnění a znovu se připojte, nebo požádejte správce pracovního prostoru o dokončení kontroly aplikace Meta.',
    readyAuth: 'Meta vyžaduje, abyste se znovu přihlásili, než bude možné načíst data z reklam.',
    readyRate: 'Meta dočasně omezila požadavky pro toto připojení. Zkuste to znovu později.',
    readyNoTools: 'Meta je připojena, ale pro tento účet neposkytla žádné nástroje.',
    readyToolsAuth:
      'Meta vyžaduje, abyste se znovu přihlásili, než bude možné její nástroje používat.',
    readyUnavailable:
      'Nástroje Meta jsou dočasně nedostupné. Zkuste připojení zkontrolovat později.',
    readyCheck:
      'Připojení Meta se momentálně nepodařilo zkontrolovat. Zkuste ho zkontrolovat později.',
    readyEmpty: 'Meta je připojena, ale zatím nejsou k dispozici žádná přístupná data.',
    readyDefault:
      'Meta je připojena, ale dostupné nástroje se nepodařilo zkontrolovat. Zkuste to znovu později.',
    completed: '{name} je připojen(a).',
    snapshotChanged: 'Tato konverzace se změnila. Před uložením aktualizujte náhled.',
    snapshotTooLarge:
      'Tato konverzace je příliš dlouhá pro jednu kopii. Požádejte Ponevu, aby uložila shrnutí jako výsledek.',
    snapshotEmpty: 'Zatím nejsou k dispozici žádné uložené zprávy ke sdílení.',
    snapshotGeneric: 'Tuto kopii se nepodařilo připravit. Zkuste to prosím znovu.',
  },
  da: {
    statusConnected: 'Forbundet',
    statusNotConnected: 'Ikke forbundet',
    statusNotConfigured: 'Ikke tilgængelig endnu',
    statusNeedsReauthorization: 'Kræver login',
    statusUnavailable: 'Utilgængelig',
    statusDisabled: 'Deaktiveret',
    audienceEveryone: 'Alle i {company}',
    audienceSelected: 'Udvalgte kolleger',
    audienceOnlyMe: 'Kun mig',
    companyPublish:
      'Du kan udgive til virksomheden. Alle i organisationen vil kunne læse dette element.',
    companyApproval:
      'Denne nøjagtige version sendes til godkendelse. Alle får først adgang, når den er godkendt.',
    companyInstant: 'Alle hos {company} kan læse dette, så snart du gemmer det.',
    connectionPlan:
      'Pipedream-forbindelser kan ikke køre værktøjer i produktion på dette arbejdsområdes nuværende plan. En administrator skal aktivere Pipedream Connect, før nogen opretter forbindelse til en konto. Eksisterende kontogodkendelser bevares.',
    connectionUnavailable:
      'Forbindelsestjenesten er utilgængelig lige nu. Prøv igen senere, eller bed en administrator for arbejdsområdet om at tjekke den. Eksisterende kontogodkendelser bevares.',
    readyMetaNoAccounts:
      'Meta er forbundet, men denne konto har ingen tilgængelige annoncekonti. Bed en Meta-administrator om at give adgang til en annoncekonto, og opret derefter forbindelse igen.',
    readyPermissions:
      'Meta er forbundet, men de nødvendige Ads-tilladelser er ikke tilgængelige. Gennemgå de anmodede tilladelser, og opret forbindelse igen, eller bed administratoren for arbejdsområdet om at færdiggøre Meta-appens gennemgang.',
    readyAuth: 'Meta kræver, at du logger ind igen, før Ads-data kan læses.',
    readyRate:
      'Meta har midlertidigt begrænset antallet af anmodninger for denne forbindelse. Prøv igen senere.',
    readyNoTools: 'Meta er forbundet, men leverede ingen værktøjer til denne konto.',
    readyToolsAuth: 'Meta kræver, at du logger ind igen, før værktøjerne kan bruges.',
    readyUnavailable:
      'Meta-værktøjer er midlertidigt utilgængelige. Prøv at tjekke forbindelsen igen senere.',
    readyCheck: 'Meta kunne ikke tjekkes lige nu. Prøv at tjekke forbindelsen igen senere.',
    readyEmpty: 'Meta er forbundet, men der er endnu ingen tilgængelige data.',
    readyDefault:
      'Meta er forbundet, men de tilgængelige værktøjer kunne ikke tjekkes. Prøv igen senere.',
    completed: '{name} er forbundet.',
    snapshotChanged: 'Denne samtale er blevet ændret. Opdater forhåndsvisningen, før du gemmer.',
    snapshotTooLarge:
      'Denne samtale er for lang til én kopi. Bed Poneva om at gemme et resumé som et Result.',
    snapshotEmpty: 'Der er endnu ingen gemte beskeder at dele.',
    snapshotGeneric: 'Vi kunne ikke forberede denne kopi. Prøv igen.',
  },
  nl: {
    statusConnected: 'Verbonden',
    statusNotConnected: 'Niet verbonden',
    statusNotConfigured: 'Nog niet beschikbaar',
    statusNeedsReauthorization: 'Opnieuw aanmelden vereist',
    statusUnavailable: 'Niet beschikbaar',
    statusDisabled: 'Uitgeschakeld',
    audienceEveryone: 'Iedereen bij {company}',
    audienceSelected: "Geselecteerde collega's",
    audienceOnlyMe: 'Alleen ik',
    companyPublish:
      'Je kunt publiceren naar het bedrijf. Iedereen in de organisatie kan dit item lezen.',
    companyApproval:
      'Deze exacte versie wordt ter goedkeuring verzonden. Iedereen krijgt pas toegang nadat deze is goedgekeurd.',
    companyInstant: 'Iedereen bij {company} kan dit lezen zodra je het opslaat.',
    connectionPlan:
      'Pipedream-verbindingen kunnen op het huidige abonnement van deze werkruimte geen tools uitvoeren in productie. Een beheerder moet Pipedream Connect inschakelen voordat iemand een account kan verbinden. Bestaande accountautorisaties blijven behouden.',
    connectionUnavailable:
      'De verbindingsservice is momenteel niet beschikbaar. Probeer het later opnieuw of vraag een werkruimtebeheerder om dit te controleren. Bestaande accountautorisaties blijven behouden.',
    readyMetaNoAccounts:
      'Meta is verbonden, maar dit account heeft geen toegankelijke advertentieaccounts. Vraag een Meta-beheerder om toegang tot een advertentieaccount te verlenen en maak daarna opnieuw verbinding.',
    readyPermissions:
      'Meta is verbonden, maar de vereiste Ads-machtigingen zijn niet beschikbaar. Controleer de gevraagde machtigingen en maak opnieuw verbinding, of vraag de werkruimtebeheerder om de Meta-appbeoordeling te voltooien.',
    readyAuth:
      'Je moet je opnieuw aanmelden bij Meta voordat de Ads-gegevens kunnen worden gelezen.',
    readyRate:
      'Meta heeft aanvragen voor deze verbinding tijdelijk beperkt. Probeer het later opnieuw.',
    readyNoTools: 'Meta is verbonden, maar heeft geen tools voor dit account geleverd.',
    readyToolsAuth:
      'Je moet je opnieuw aanmelden bij Meta voordat de tools kunnen worden gebruikt.',
    readyUnavailable:
      'Meta-tools zijn tijdelijk niet beschikbaar. Controleer de verbinding later opnieuw.',
    readyCheck:
      'Meta kon momenteel niet worden gecontroleerd. Controleer de verbinding later opnieuw.',
    readyEmpty: 'Meta is verbonden, maar er zijn nog geen toegankelijke gegevens.',
    readyDefault:
      'Meta is verbonden, maar de beschikbare tools konden niet worden gecontroleerd. Probeer het later opnieuw.',
    completed: '{name} is verbonden.',
    snapshotChanged: 'Dit gesprek is gewijzigd. Vernieuw het voorbeeld voordat je het opslaat.',
    snapshotTooLarge:
      'Dit gesprek is te lang voor één kopie. Vraag Poneva om een samenvatting op te slaan als Resultaat.',
    snapshotEmpty: 'Er zijn nog geen opgeslagen berichten om te delen.',
    snapshotGeneric: 'We konden deze kopie niet voorbereiden. Probeer het opnieuw.',
  },
  et: {
    statusConnected: 'Ühendatud',
    statusNotConnected: 'Pole ühendatud',
    statusNotConfigured: 'Pole veel saadaval',
    statusNeedsReauthorization: 'Vajab uuesti sisselogimist',
    statusUnavailable: 'Pole saadaval',
    statusDisabled: 'Välja lülitatud',
    audienceEveryone: 'Kõik ettevõtte {company} liikmed',
    audienceSelected: 'Valitud kolleegid',
    audienceOnlyMe: 'Ainult mina',
    companyPublish:
      'Saad ettevõttes avaldada. Kõik organisatsiooni liikmed saavad seda elementi lugeda.',
    companyApproval:
      'See täpselt sama versioon saadetakse kinnitamiseks. Kõik saavad juurdepääsu alles pärast selle kinnitamist.',
    companyInstant: 'Kõik ettevõtte {company} liikmed saavad seda lugeda kohe pärast salvestamist.',
    connectionPlan:
      'Pipedreami ühendused ei saa selle tööruumi praeguse paketi alusel tootmises tööriistu käivitada. Administraator peab enne mis tahes konto ühendamist lubama Pipedream Connecti. Olemasolevad konto autoriseerimised säilitatakse.',
    connectionUnavailable:
      'Ühenduse teenus pole praegu saadaval. Proovi hiljem uuesti või palu tööruumi administraatoril seda kontrollida. Olemasolevad konto autoriseerimised säilitatakse.',
    readyMetaNoAccounts:
      'Meta on ühendatud, kuid sellel kontol pole juurdepääsetavaid reklaamikontosid. Palu Meta administraatoril anda juurdepääs reklaamikontole ja ühenda konto seejärel uuesti.',
    readyPermissions:
      'Meta on ühendatud, kuid nõutud reklaamide õigused pole saadaval. Vaata taotletud õigused üle ja ühenda uuesti või palu tööruumi administraatoril Meta rakenduse ülevaatus lõpule viia.',
    readyAuth: 'Meta nõuab uuesti sisselogimist, enne kui selle reklaamiandmeid saab lugeda.',
    readyRate: 'Meta piiras selle ühenduse päringuid ajutiselt. Proovi hiljem uuesti.',
    readyNoTools: 'Meta on ühendatud, kuid ei pakkunud selle konto jaoks ühtegi tööriista.',
    readyToolsAuth: 'Meta nõuab uuesti sisselogimist, enne kui selle tööriistu saab kasutada.',
    readyUnavailable:
      'Meta tööriistad pole ajutiselt saadaval. Proovi ühendust hiljem uuesti kontrollida.',
    readyCheck:
      'Meta ühendust ei saanud praegu kontrollida. Proovi ühendust hiljem uuesti kontrollida.',
    readyEmpty: 'Meta on ühendatud, kuid juurdepääsetavaid andmeid veel pole.',
    readyDefault:
      'Meta on ühendatud, kuid selle saadaolevaid tööriistu ei saanud kontrollida. Proovi hiljem uuesti.',
    completed: '{name} on ühendatud.',
    snapshotChanged: 'See vestlus muutus. Värskenda eelvaadet enne salvestamist.',
    snapshotTooLarge:
      'See vestlus on ühe koopia jaoks liiga pikk. Palu Poneval salvestada kokkuvõte tulemuseks.',
    snapshotEmpty: 'Jagamiseks pole veel salvestatud sõnumeid.',
    snapshotGeneric: 'Seda koopiat ei saanud ette valmistada. Proovi uuesti.',
  },
  fi: {
    statusConnected: 'Yhdistetty',
    statusNotConnected: 'Ei yhdistetty',
    statusNotConfigured: 'Ei vielä saatavilla',
    statusNeedsReauthorization: 'Edellyttää kirjautumista',
    statusUnavailable: 'Ei saatavilla',
    statusDisabled: 'Poistettu käytöstä',
    audienceEveryone: 'Kaikki yrityksen {company} jäsenet',
    audienceSelected: 'Valitut kollegat',
    audienceOnlyMe: 'Vain minä',
    companyPublish:
      'Voit julkaista yritykselle. Kaikki organisaation jäsenet voivat lukea tämän kohteen.',
    companyApproval:
      'Tämä täsmällinen versio lähetetään hyväksyttäväksi. Kaikki saavat käyttöoikeuden vasta hyväksynnän jälkeen.',
    companyInstant:
      'Kaikki yrityksen {company} jäsenet voivat lukea tämän heti tallennuksen jälkeen.',
    connectionPlan:
      'Pipedream-yhteydet eivät voi käyttää työkaluja tuotannossa tämän työtilan nykyisellä paketilla. Järjestelmänvalvojan on otettava Pipedream Connect käyttöön, ennen kuin kukaan yhdistää tiliä. Aiemmat tilivaltuutukset säilyvät.',
    connectionUnavailable:
      'Yhteyspalvelu ei ole juuri nyt käytettävissä. Yritä myöhemmin uudelleen tai pyydä työtilan järjestelmänvalvojaa tarkistamaan asia. Aiemmat tilivaltuutukset säilyvät.',
    readyMetaNoAccounts:
      'Meta on yhdistetty, mutta tällä tilillä ei ole käytettävissä olevia mainostilejä. Pyydä Metan järjestelmänvalvojaa myöntämään käyttöoikeus mainostiliin ja yhdistä sitten uudelleen.',
    readyPermissions:
      'Meta on yhdistetty, mutta vaadittuja mainosten käyttöoikeuksia ei ole saatavilla. Tarkista pyydetyt käyttöoikeudet ja yhdistä uudelleen tai pyydä työtilan järjestelmänvalvojaa viimeistelemään Metan sovellustarkistus.',
    readyAuth: 'Meta edellyttää uutta kirjautumista, ennen kuin sen mainostietoja voidaan lukea.',
    readyRate: 'Meta rajoitti tämän yhteyden pyyntöjä tilapäisesti. Yritä myöhemmin uudelleen.',
    readyNoTools: 'Meta on yhdistetty, mutta se ei tarjonnut tälle tilille työkaluja.',
    readyToolsAuth:
      'Meta edellyttää uutta kirjautumista, ennen kuin sen työkaluja voidaan käyttää.',
    readyUnavailable:
      'Metan työkalut eivät ole tilapäisesti käytettävissä. Yritä tarkistaa yhteys myöhemmin uudelleen.',
    readyCheck: 'Metaa ei voitu tarkistaa juuri nyt. Yritä tarkistaa yhteys myöhemmin uudelleen.',
    readyEmpty: 'Meta on yhdistetty, mutta käytettävissä olevia tietoja ei vielä ole.',
    readyDefault:
      'Meta on yhdistetty, mutta sen käytettävissä olevia työkaluja ei voitu tarkistaa. Yritä myöhemmin uudelleen.',
    completed: '{name} on yhdistetty.',
    snapshotChanged: 'Tämä keskustelu muuttui. Päivitä esikatselu ennen tallentamista.',
    snapshotTooLarge:
      'Tämä keskustelu on liian pitkä yhteen kopioon. Pyydä Ponevaa tallentamaan yhteenveto sen sijaan tuloksena.',
    snapshotEmpty: 'Jaettavia tallennettuja viestejä ei vielä ole.',
    snapshotGeneric: 'Emme voineet valmistella tätä kopiota. Yritä uudelleen.',
  },
  fr: {
    statusConnected: 'Connecté',
    statusNotConnected: 'Non connecté',
    statusNotConfigured: 'Pas encore disponible',
    statusNeedsReauthorization: 'Nouvelle connexion requise',
    statusUnavailable: 'Indisponible',
    statusDisabled: 'Désactivé',
    audienceEveryone: 'Tout le monde chez {company}',
    audienceSelected: 'Collègues sélectionnés',
    audienceOnlyMe: 'Moi uniquement',
    companyPublish:
      'Vous pouvez publier dans l’entreprise. Tout le monde dans l’organisation pourra lire cet élément.',
    companyApproval:
      'Cette version exacte sera envoyée pour approbation. Tout le monde y aura accès uniquement après son approbation.',
    companyInstant:
      'Tout le monde chez {company} pourra lire ceci dès que vous l’aurez enregistré.',
    connectionPlan:
      'Les connexions Pipedream ne peuvent pas exécuter d’outils en production avec le forfait actuel de cet espace de travail. Un administrateur doit activer Pipedream Connect avant que quiconque puisse connecter un compte. Les autorisations de comptes existantes sont conservées.',
    connectionUnavailable:
      'Le service de connexion est indisponible pour le moment. Réessayez plus tard ou demandez à un administrateur de l’espace de travail de vérifier le problème. Les autorisations de comptes existantes sont conservées.',
    readyMetaNoAccounts:
      'Meta est connecté, mais ce compte n’a accès à aucun compte publicitaire. Demandez à un administrateur Meta de vous accorder l’accès à un compte publicitaire, puis reconnectez-vous.',
    readyPermissions:
      'Meta est connecté, mais les autorisations publicitaires requises ne sont pas disponibles. Vérifiez les autorisations demandées et reconnectez-vous, ou demandez à l’administrateur de l’espace de travail de terminer l’examen de l’application Meta.',
    readyAuth:
      'Meta vous demande de vous reconnecter avant de pouvoir lire ses données publicitaires.',
    readyRate:
      'Meta a temporairement limité les requêtes pour cette connexion. Réessayez plus tard.',
    readyNoTools: 'Meta est connecté, mais n’a fourni aucun outil pour ce compte.',
    readyToolsAuth: 'Meta vous demande de vous reconnecter avant de pouvoir utiliser ses outils.',
    readyUnavailable:
      'Les outils Meta sont temporairement indisponibles. Réessayez de vérifier la connexion plus tard.',
    readyCheck:
      'Meta n’a pas pu être vérifié pour le moment. Réessayez de vérifier la connexion plus tard.',
    readyEmpty: 'Meta est connecté, mais aucune donnée accessible n’est encore disponible.',
    readyDefault:
      'Meta est connecté, mais ses outils disponibles n’ont pas pu être vérifiés. Réessayez plus tard.',
    completed: '{name} est connecté.',
    snapshotChanged: 'Cette conversation a changé. Actualisez l’aperçu avant d’enregistrer.',
    snapshotTooLarge:
      'Cette conversation est trop longue pour être copiée en une seule fois. Demandez à Poneva d’enregistrer un résumé en tant que Résultat.',
    snapshotEmpty: 'Aucun message enregistré n’est encore disponible pour le partage.',
    snapshotGeneric: 'Nous n’avons pas pu préparer cette copie. Veuillez réessayer.',
  },
  de: {
    statusConnected: 'Verbunden',
    statusNotConnected: 'Nicht verbunden',
    statusNotConfigured: 'Noch nicht eingerichtet',
    statusNeedsReauthorization: 'Erneute Anmeldung erforderlich',
    statusUnavailable: 'Nicht verfügbar',
    statusDisabled: 'Deaktiviert',
    audienceEveryone: 'Alle bei {company}',
    audienceSelected: 'Ausgewählte Kolleginnen und Kollegen',
    audienceOnlyMe: 'Nur ich',
    companyPublish:
      'Sie können für das Unternehmen veröffentlichen. Alle in der Organisation können dieses Element lesen.',
    companyApproval:
      'Diese genaue Version wird zur Genehmigung gesendet. Alle erhalten erst nach der Genehmigung Zugriff.',
    companyInstant: 'Alle bei {company} können dies lesen, sobald Sie speichern.',
    connectionPlan:
      'Pipedream-Verbindungen können in diesem Arbeitsbereich mit dem aktuellen Tarif keine Tools in der Produktion ausführen. Ein Admin muss Pipedream Connect aktivieren, bevor jemand ein Konto verbindet. Bestehende Kontoberechtigungen bleiben erhalten.',
    connectionUnavailable:
      'Der Verbindungsdienst ist derzeit nicht verfügbar. Versuchen Sie es später erneut oder bitten Sie einen Arbeitsbereich-Admin, dies zu prüfen. Bestehende Kontoberechtigungen bleiben erhalten.',
    readyMetaNoAccounts:
      'Meta ist verbunden, aber dieses Konto hat keine zugänglichen Werbekonten. Bitten Sie einen Meta-Admin, Ihnen Zugriff auf ein Werbekonto zu gewähren, und verbinden Sie anschließend erneut.',
    readyPermissions:
      'Meta ist verbunden, aber die erforderlichen Werbeanzeigen-Berechtigungen sind nicht verfügbar. Überprüfen Sie die angeforderten Berechtigungen und verbinden Sie erneut, oder bitten Sie den Arbeitsbereich-Admin, die Überprüfung der Meta-App abzuschließen.',
    readyAuth:
      'Sie müssen sich erneut bei Meta anmelden, bevor die Werbeanzeigendaten gelesen werden können.',
    readyRate:
      'Meta hat Anfragen für diese Verbindung vorübergehend eingeschränkt. Versuchen Sie es später erneut.',
    readyNoTools: 'Meta ist verbunden, hat für dieses Konto jedoch keine Tools bereitgestellt.',
    readyToolsAuth:
      'Sie müssen sich erneut bei Meta anmelden, bevor die Tools verwendet werden können.',
    readyUnavailable:
      'Die Meta-Tools sind vorübergehend nicht verfügbar. Überprüfen Sie die Verbindung später erneut.',
    readyCheck:
      'Meta konnte gerade nicht überprüft werden. Überprüfen Sie die Verbindung später erneut.',
    readyEmpty: 'Meta ist verbunden, aber es sind noch keine zugänglichen Daten vorhanden.',
    readyDefault:
      'Meta ist verbunden, aber die verfügbaren Tools konnten nicht überprüft werden. Versuchen Sie es später erneut.',
    completed: '{name} ist verbunden.',
    snapshotChanged:
      'Diese Unterhaltung wurde geändert. Aktualisieren Sie die Vorschau, bevor Sie speichern.',
    snapshotTooLarge:
      'Diese Unterhaltung ist zu lang für eine einzelne Kopie. Bitten Sie Poneva, stattdessen eine Zusammenfassung als Ergebnis zu speichern.',
    snapshotEmpty: 'Es gibt noch keine gespeicherten Nachrichten zum Teilen.',
    snapshotGeneric: 'Diese Kopie konnte nicht erstellt werden. Versuchen Sie es erneut.',
  },
  el: {
    statusConnected: 'Συνδεδεμένο',
    statusNotConnected: 'Δεν είναι συνδεδεμένο',
    statusNotConfigured: 'Δεν είναι ακόμη διαθέσιμο',
    statusNeedsReauthorization: 'Απαιτείται νέα σύνδεση',
    statusUnavailable: 'Μη διαθέσιμο',
    statusDisabled: 'Απενεργοποιημένο',
    audienceEveryone: 'Όλοι στην εταιρεία {company}',
    audienceSelected: 'Επιλεγμένοι συνάδελφοι',
    audienceOnlyMe: 'Μόνο εγώ',
    companyPublish:
      'Μπορείτε να το δημοσιεύσετε στην εταιρεία. Όλοι στον οργανισμό θα μπορούν να διαβάσουν αυτό το στοιχείο.',
    companyApproval:
      'Αυτή η ακριβής έκδοση θα σταλεί για έγκριση. Όλοι θα αποκτήσουν πρόσβαση μόνο αφού εγκριθεί.',
    companyInstant: 'Όλοι στην εταιρεία {company} μπορούν να το διαβάσουν μόλις το αποθηκεύσετε.',
    connectionPlan:
      'Οι συνδέσεις Pipedream δεν μπορούν να εκτελούν εργαλεία σε περιβάλλον παραγωγής με το τρέχον πρόγραμμα αυτού του χώρου εργασίας. Ένας διαχειριστής πρέπει να ενεργοποιήσει το Pipedream Connect πριν συνδέσει οποιοσδήποτε λογαριασμό. Οι υπάρχουσες εξουσιοδοτήσεις λογαριασμών διατηρούνται.',
    connectionUnavailable:
      'Η υπηρεσία σύνδεσης δεν είναι διαθέσιμη αυτήν τη στιγμή. Δοκιμάστε ξανά αργότερα ή ζητήστε από έναν διαχειριστή του χώρου εργασίας να το ελέγξει. Οι υπάρχουσες εξουσιοδοτήσεις λογαριασμών διατηρούνται.',
    readyMetaNoAccounts:
      'Το Meta είναι συνδεδεμένο, αλλά αυτός ο λογαριασμός δεν έχει προσβάσιμους διαφημιστικούς λογαριασμούς. Ζητήστε από έναν διαχειριστή του Meta να σας παραχωρήσει πρόσβαση σε έναν διαφημιστικό λογαριασμό και, στη συνέχεια, συνδεθείτε ξανά.',
    readyPermissions:
      'Το Meta είναι συνδεδεμένο, αλλά δεν είναι διαθέσιμα τα απαιτούμενα δικαιώματα διαφημίσεων. Ελέγξτε τα ζητούμενα δικαιώματα και συνδεθείτε ξανά ή ζητήστε από τον διαχειριστή του χώρου εργασίας να ολοκληρώσει τον έλεγχο της εφαρμογής Meta.',
    readyAuth:
      'Το Meta χρειάζεται να συνδεθείτε ξανά προτού είναι δυνατή η ανάγνωση των δεδομένων διαφημίσεών του.',
    readyRate:
      'Το Meta περιόρισε προσωρινά τα αιτήματα για αυτήν τη σύνδεση. Δοκιμάστε ξανά αργότερα.',
    readyNoTools: 'Το Meta είναι συνδεδεμένο, αλλά δεν παρείχε εργαλεία για αυτόν τον λογαριασμό.',
    readyToolsAuth:
      'Το Meta χρειάζεται να συνδεθείτε ξανά προτού μπορέσετε να χρησιμοποιήσετε τα εργαλεία του.',
    readyUnavailable:
      'Τα εργαλεία του Meta δεν είναι προσωρινά διαθέσιμα. Δοκιμάστε να ελέγξετε ξανά τη σύνδεση αργότερα.',
    readyCheck:
      'Δεν ήταν δυνατός ο έλεγχος του Meta αυτήν τη στιγμή. Δοκιμάστε να ελέγξετε ξανά τη σύνδεση αργότερα.',
    readyEmpty: 'Το Meta είναι συνδεδεμένο, αλλά δεν υπάρχουν ακόμη προσβάσιμα δεδομένα.',
    readyDefault:
      'Το Meta είναι συνδεδεμένο, αλλά δεν ήταν δυνατός ο έλεγχος των διαθέσιμων εργαλείων του. Δοκιμάστε ξανά αργότερα.',
    completed: 'Το {name} είναι συνδεδεμένο.',
    snapshotChanged:
      'Αυτή η συνομιλία άλλαξε. Ανανεώστε την προεπισκόπηση πριν από την αποθήκευση.',
    snapshotTooLarge:
      'Αυτή η συνομιλία είναι πολύ μεγάλη για ένα αντίγραφο. Ζητήστε από το Poneva να αποθηκεύσει μια σύνοψη ως Result.',
    snapshotEmpty: 'Δεν υπάρχουν ακόμη αποθηκευμένα μηνύματα για κοινή χρήση.',
    snapshotGeneric: 'Δεν ήταν δυνατή η προετοιμασία αυτού του αντιγράφου. Δοκιμάστε ξανά.',
  },
  hu: {
    statusConnected: 'Kapcsolódva',
    statusNotConnected: 'Nincs kapcsolat',
    statusNotConfigured: 'Még nem érhető el',
    statusNeedsReauthorization: 'Újra be kell jelentkezni',
    statusUnavailable: 'Nem érhető el',
    statusDisabled: 'Kikapcsolva',
    audienceEveryone: 'A(z) {company} minden tagja',
    audienceSelected: 'Kiválasztott kollégák',
    audienceOnlyMe: 'Csak én',
    companyPublish:
      'Közzétehet a vállalatnál. A szervezet minden tagja el tudja majd olvasni ezt az elemet.',
    companyApproval:
      'Ezt a pontos verziót jóváhagyásra küldjük. Mindenki csak a jóváhagyás után kap hozzáférést.',
    companyInstant: 'A(z) {company} minden tagja elolvashatja, amint menti.',
    connectionPlan:
      'A Pipedream-kapcsolatok nem tudnak eszközöket futtatni éles környezetben ezen a munkaterületen a jelenlegi csomaggal. Egy adminisztrátornak engedélyeznie kell a Pipedream Connectet, mielőtt bárki fiókot csatlakoztatna. A meglévő fiókengedélyezések megmaradnak.',
    connectionUnavailable:
      'A kapcsolati szolgáltatás jelenleg nem érhető el. Próbálja újra később, vagy kérje meg a munkaterület adminisztrátorát, hogy ellenőrizze. A meglévő fiókengedélyezések megmaradnak.',
    readyMetaNoAccounts:
      'A Meta csatlakoztatva van, de ehhez a fiókhoz nem érhetők el hirdetési fiókok. Kérje meg a Meta egyik adminisztrátorát, hogy adjon hozzáférést egy hirdetési fiókhoz, majd csatlakozzon újra.',
    readyPermissions:
      'A Meta csatlakoztatva van, de a szükséges hirdetési engedélyek nem érhetők el. Ellenőrizze a kért engedélyeket, és csatlakozzon újra, vagy kérje meg a munkaterület adminisztrátorát a Meta-alkalmazás ellenőrzésének befejezésére.',
    readyAuth: 'A Metának újra be kell jelentkeznie, mielőtt az Ads-adatai olvashatók lennének.',
    readyRate:
      'A Meta ideiglenesen korlátozta a kéréseket ehhez a kapcsolathoz. Próbálja újra később.',
    readyNoTools: 'A Meta csatlakoztatva van, de nem biztosított eszközöket ehhez a fiókhoz.',
    readyToolsAuth:
      'A Metába újra be kell jelentkeznie, mielőtt az eszközei használhatók lennének.',
    readyUnavailable:
      'A Meta eszközei ideiglenesen nem érhetők el. Próbálja később újra ellenőrizni a kapcsolatot.',
    readyCheck:
      'A Meta ellenőrzése jelenleg nem sikerült. Próbálja később újra ellenőrizni a kapcsolatot.',
    readyEmpty: 'A Meta csatlakoztatva van, de egyelőre nincs hozzáférhető adat.',
    readyDefault:
      'A Meta csatlakoztatva van, de az elérhető eszközeit nem sikerült ellenőrizni. Próbálja újra később.',
    completed: '{name} csatlakoztatva.',
    snapshotChanged: 'Ez a beszélgetés megváltozott. Frissítse az előnézetet mentés előtt.',
    snapshotTooLarge:
      'Ez a beszélgetés túl hosszú egyetlen másolathoz. Kérje meg a Ponevát, hogy mentsen összefoglalót Resultként.',
    snapshotEmpty: 'Még nincsenek megosztható mentett üzenetek.',
    snapshotGeneric: 'Nem sikerült előkészítenünk ezt a másolatot. Próbálja újra.',
  },
  ga: {
    statusConnected: 'Ceangailte',
    statusNotConnected: 'Níl sé ceangailte',
    statusNotConfigured: 'Níl sé ar fáil fós',
    statusNeedsReauthorization: 'Ní mór duit síniú isteach arís',
    statusUnavailable: 'Níl sé ar fáil',
    statusDisabled: 'Múchta',
    audienceEveryone: 'Gach duine ag {company}',
    audienceSelected: 'Comhghleacaithe roghnaithe',
    audienceOnlyMe: 'Mise amháin',
    companyPublish:
      'Is féidir leat foilsiú don chuideachta. Beidh gach duine san eagraíocht in ann an mhír seo a léamh.',
    companyApproval:
      'Seolfar an leagan cruinn seo lena cheadú. Ní bhfaighidh aon duine rochtain go dtí go gceadófar é.',
    companyInstant:
      'Beidh gach duine ag {company} in ann é seo a léamh a luaithe a shábhálfaidh tú é.',
    connectionPlan:
      'Ní féidir le naisc Pipedream uirlisí a rith i dtimpeallacht táirgthe ar phlean reatha an spáis oibre seo. Ní mór do riarthóir Pipedream Connect a chumasú sula nascfaidh aon duine cuntas. Coinnítear údaruithe cuntais atá ann cheana.',
    connectionUnavailable:
      'Níl an tseirbhís naisc ar fáil faoi láthair. Bain triail eile as níos déanaí nó iarr ar riarthóir an spáis oibre é a sheiceáil. Coinnítear údaruithe cuntais atá ann cheana.',
    readyMetaNoAccounts:
      'Tá Meta ceangailte, ach níl aon chuntais fógraí inrochtana ag an gcuntas seo. Iarr ar riarthóir Meta rochtain a thabhairt ar chuntas fógraí, ansin athcheangail.',
    readyPermissions:
      "Tá Meta ceangailte, ach níl na ceadanna riachtanacha d'fhógraí ar fáil. Déan athbhreithniú ar na ceadanna iarrtha agus athcheangail, nó iarr ar riarthóir an spáis oibre athbhreithniú na haipe Meta a chríochnú.",
    readyAuth: 'Ní mór duit síniú isteach arís i Meta sular féidir a shonraí fógraí a léamh.',
    readyRate:
      'Chuir Meta teorainn shealadach le hiarratais don nasc seo. Bain triail eile as níos déanaí.',
    readyNoTools: 'Tá Meta ceangailte, ach níor chuir sé aon uirlisí ar fáil don chuntas seo.',
    readyToolsAuth: 'Ní mór duit síniú isteach arís i Meta sular féidir a chuid uirlisí a úsáid.',
    readyUnavailable:
      'Níl uirlisí Meta ar fáil go sealadach. Bain triail as an nasc a sheiceáil arís níos déanaí.',
    readyCheck:
      'Níorbh fhéidir Meta a sheiceáil faoi láthair. Bain triail as an nasc a sheiceáil arís níos déanaí.',
    readyEmpty: 'Tá Meta ceangailte, ach níl aon sonraí inrochtana ann fós.',
    readyDefault:
      'Tá Meta ceangailte, ach níorbh fhéidir na huirlisí atá ar fáil dó a sheiceáil. Bain triail eile as níos déanaí.',
    completed: 'Tá {name} ceangailte.',
    snapshotChanged: "D'athraigh an comhrá seo. Athnuachan an réamhamharc sula sábhálfaidh tú é.",
    snapshotTooLarge:
      'Tá an comhrá seo rófhada le haghaidh cóipe amháin. Iarr ar Poneva achoimre a shábháil mar Thoradh ina áit.',
    snapshotEmpty: 'Níl aon teachtaireachtaí sábháilte le roinnt fós.',
    snapshotGeneric: 'Níorbh fhéidir linn an chóip seo a ullmhú. Bain triail eile as le do thoil.',
  },
  it: {
    statusConnected: 'Connesso',
    statusNotConnected: 'Non connesso',
    statusNotConfigured: 'Non ancora disponibile',
    statusNeedsReauthorization: 'Richiede un nuovo accesso',
    statusUnavailable: 'Non disponibile',
    statusDisabled: 'Disattivato',
    audienceEveryone: 'Tutti in {company}',
    audienceSelected: 'Colleghi selezionati',
    audienceOnlyMe: 'Solo io',
    companyPublish:
      "Puoi pubblicare per l'azienda. Tutti nell'organizzazione potranno leggere questo elemento.",
    companyApproval:
      "Questa versione esatta verrà inviata per l'approvazione. Tutti otterranno l'accesso solo dopo l'approvazione.",
    companyInstant: 'Tutti in {company} potranno leggere questo elemento non appena lo salvi.',
    connectionPlan:
      'Le connessioni Pipedream non possono eseguire strumenti in produzione nello spazio di lavoro con il piano attuale. Un amministratore deve abilitare Pipedream Connect prima che chiunque colleghi un account. Le autorizzazioni degli account esistenti vengono mantenute.',
    connectionUnavailable:
      'Il servizio di connessione non è al momento disponibile. Riprova più tardi o chiedi a un amministratore dello spazio di lavoro di controllare. Le autorizzazioni degli account esistenti vengono mantenute.',
    readyMetaNoAccounts:
      "Meta è connesso, ma questo account non ha account pubblicitari accessibili. Chiedi a un amministratore Meta di concedere l'accesso a un account pubblicitario, quindi riconnettiti.",
    readyPermissions:
      "Meta è connesso, ma le autorizzazioni Ads richieste non sono disponibili. Controlla le autorizzazioni richieste e riconnettiti, oppure chiedi all'amministratore dello spazio di lavoro di completare la revisione dell'app Meta.",
    readyAuth: 'Meta richiede un nuovo accesso prima di poter leggere i dati Ads.',
    readyRate:
      'Meta ha limitato temporaneamente le richieste per questa connessione. Riprova più tardi.',
    readyNoTools: 'Meta è connesso, ma non ha fornito strumenti per questo account.',
    readyToolsAuth: 'Meta richiede un nuovo accesso prima di poter utilizzare i suoi strumenti.',
    readyUnavailable:
      'Gli strumenti Meta non sono temporaneamente disponibili. Prova a controllare di nuovo la connessione più tardi.',
    readyCheck:
      'Non è stato possibile controllare Meta al momento. Prova a controllare di nuovo la connessione più tardi.',
    readyEmpty: 'Meta è connesso, ma non ci sono ancora dati accessibili.',
    readyDefault:
      'Meta è connesso, ma non è stato possibile controllare gli strumenti disponibili. Riprova più tardi.',
    completed: '{name} è connesso.',
    snapshotChanged: "Questa conversazione è cambiata. Aggiorna l'anteprima prima di salvare.",
    snapshotTooLarge:
      'Questa conversazione è troppo lunga per una singola copia. Chiedi a Poneva di salvare un riepilogo come Risultato.',
    snapshotEmpty: 'Non ci sono ancora messaggi salvati da condividere.',
    snapshotGeneric: 'Non è stato possibile preparare questa copia. Riprova.',
  },
  lv: {
    statusConnected: 'Savienots',
    statusNotConnected: 'Nav savienots',
    statusNotConfigured: 'Vēl nav pieejams',
    statusNeedsReauthorization: 'Nepieciešams pierakstīties',
    statusUnavailable: 'Nav pieejams',
    statusDisabled: 'Izslēgts',
    audienceEveryone: 'Ikviens uzņēmumā {company}',
    audienceSelected: 'Atlasītie kolēģi',
    audienceOnlyMe: 'Tikai es',
    companyPublish: 'Varat publicēt uzņēmumam. Ikviens organizācijā varēs izlasīt šo vienumu.',
    companyApproval:
      'Šī precīzā versija tiks nosūtīta apstiprināšanai. Piekļuve visiem tiks piešķirta tikai pēc apstiprināšanas.',
    companyInstant: 'Ikviens uzņēmumā {company} varēs to izlasīt, tiklīdz to saglabāsiet.',
    connectionPlan:
      'Pipedream savienojumi šī darbvietas pašreizējā plānā nevar palaist rīkus ražošanas vidē. Administratoram ir jāiespējo Pipedream Connect, pirms kāds var pievienot kontu. Esošās kontu autorizācijas tiek saglabātas.',
    connectionUnavailable:
      'Savienojuma pakalpojums pašlaik nav pieejams. Mēģiniet vēlāk vai lūdziet darbvietas administratoram to pārbaudīt. Esošās kontu autorizācijas tiek saglabātas.',
    readyMetaNoAccounts:
      'Meta ir savienots, taču šim kontam nav pieejamu reklāmas kontu. Lūdziet Meta administratoram piešķirt piekļuvi reklāmas kontam un pēc tam izveidojiet savienojumu vēlreiz.',
    readyPermissions:
      'Meta ir savienots, taču nepieciešamās Ads atļaujas nav pieejamas. Pārskatiet pieprasītās atļaujas un izveidojiet savienojumu vēlreiz vai lūdziet darbvietas administratoram pabeigt Meta lietotnes pārskatīšanu.',
    readyAuth: 'Meta pieprasa pierakstīties vēlreiz, pirms var nolasīt Ads datus.',
    readyRate: 'Meta uz laiku ierobežoja šī savienojuma pieprasījumus. Mēģiniet vēlāk.',
    readyNoTools: 'Meta ir savienots, taču šim kontam netika nodrošināti nekādi rīki.',
    readyToolsAuth: 'Meta pieprasa pierakstīties vēlreiz, pirms var izmantot tā rīkus.',
    readyUnavailable:
      'Meta rīki īslaicīgi nav pieejami. Mēģiniet vēlāk vēlreiz pārbaudīt savienojumu.',
    readyCheck: 'Meta pašlaik nevarēja pārbaudīt. Mēģiniet vēlāk vēlreiz pārbaudīt savienojumu.',
    readyEmpty: 'Meta ir savienots, taču pagaidām nav pieejamu datu.',
    readyDefault: 'Meta ir savienots, taču pieejamos rīkus nevarēja pārbaudīt. Mēģiniet vēlāk.',
    completed: '{name} ir savienots.',
    snapshotChanged: 'Šī saruna ir mainīta. Pirms saglabāšanas atsvaidziniet priekšskatījumu.',
    snapshotTooLarge:
      'Šī saruna ir pārāk gara, lai to saglabātu vienā kopijā. Lūdziet Poneva saglabāt kopsavilkumu kā rezultātu.',
    snapshotEmpty: 'Pagaidām nav saglabātu ziņojumu, ko kopīgot.',
    snapshotGeneric: 'Neizdevās sagatavot šo kopiju. Lūdzu, mēģiniet vēlreiz.',
  },
  lt: {
    statusConnected: 'Prisijungta',
    statusNotConnected: 'Neprisijungta',
    statusNotConfigured: 'Dar nepasiekiama',
    statusNeedsReauthorization: 'Reikia prisijungti',
    statusUnavailable: 'Nepasiekiama',
    statusDisabled: 'Išjungta',
    audienceEveryone: 'Visi įmonės {company} darbuotojai',
    audienceSelected: 'Pasirinkti kolegos',
    audienceOnlyMe: 'Tik aš',
    companyPublish:
      'Galite paskelbti visai įmonei. Visi organizacijos nariai galės perskaityti šį elementą.',
    companyApproval:
      'Ši tiksli versija bus išsiųsta patvirtinti. Visi prieigą gaus tik ją patvirtinus.',
    companyInstant:
      'Visi įmonės {company} darbuotojai galės tai perskaityti iškart, kai išsaugosite.',
    connectionPlan:
      'Pagal dabartinį šios darbo srities planą „Pipedream“ ryšiai negali paleisti įrankių gamybinėje aplinkoje. Administratorius turi įjungti „Pipedream Connect“, kad kas nors galėtų prijungti paskyrą. Esami paskyrų suteikti leidimai išsaugomi.',
    connectionUnavailable:
      'Ryšio paslauga šiuo metu nepasiekiama. Pabandykite vėliau arba paprašykite darbo srities administratoriaus tai patikrinti. Esami paskyrų suteikti leidimai išsaugomi.',
    readyMetaNoAccounts:
      'Meta prijungta, tačiau ši paskyra neturi pasiekiamų reklamų paskyrų. Paprašykite Meta administratoriaus suteikti prieigą prie reklamų paskyros ir prisijunkite iš naujo.',
    readyPermissions:
      'Meta prijungta, tačiau reikiami reklamų leidimai nepasiekiami. Peržiūrėkite prašomus leidimus ir prisijunkite iš naujo arba paprašykite darbo srities administratoriaus užbaigti Meta programos patikrą.',
    readyAuth: 'Prieš nuskaitant Meta reklamų duomenis reikia prisijungti iš naujo.',
    readyRate: 'Meta laikinai apribojo šio ryšio užklausas. Pabandykite vėliau.',
    readyNoTools: 'Meta prijungta, tačiau šiai paskyrai nepateikė jokių įrankių.',
    readyToolsAuth: 'Prieš naudojant Meta įrankius reikia prisijungti iš naujo.',
    readyUnavailable:
      'Meta įrankiai laikinai nepasiekiami. Pabandykite vėliau dar kartą patikrinti ryšį.',
    readyCheck: 'Šiuo metu nepavyko patikrinti Meta. Pabandykite vėliau dar kartą patikrinti ryšį.',
    readyEmpty: 'Meta prijungta, tačiau pasiekiamų duomenų dar nėra.',
    readyDefault:
      'Meta prijungta, tačiau nepavyko patikrinti jos pasiekiamų įrankių. Pabandykite vėliau.',
    completed: '{name} prijungta.',
    snapshotChanged: 'Šis pokalbis pasikeitė. Prieš išsaugodami atnaujinkite peržiūrą.',
    snapshotTooLarge:
      'Šis pokalbis per ilgas vienai kopijai. Paprašykite „Poneva“ išsaugoti santrauką kaip rezultatą.',
    snapshotEmpty: 'Kol kas nėra išsaugotų pranešimų, kuriuos būtų galima bendrinti.',
    snapshotGeneric: 'Nepavyko paruošti šios kopijos. Pabandykite dar kartą.',
  },
  mt: {
    statusConnected: 'Konness',
    statusNotConnected: 'Mhux konness',
    statusNotConfigured: 'Għadu mhux disponibbli',
    statusNeedsReauthorization: 'Jeħtieġ terġa’ tidħol',
    statusUnavailable: 'Mhux disponibbli',
    statusDisabled: 'Mitfi',
    audienceEveryone: 'Kulħadd f’{company}',
    audienceSelected: 'Kollegi magħżula',
    audienceOnlyMe: 'Jien biss',
    companyPublish:
      'Tista’ tippubblika lill-kumpanija. Kulħadd fl-organizzazzjoni jkun jista’ jaqra dan l-oġġett.',
    companyApproval:
      'Din il-verżjoni eżatta tintbagħat għall-approvazzjoni. Kulħadd ikollu aċċess biss wara li tiġi approvata.',
    companyInstant: 'Kulħadd f’{company} jista’ jaqra dan malli tissejvja.',
    connectionPlan:
      'Il-konnessjonijiet ta’ Pipedream ma jistgħux iħaddmu għodod fil-produzzjoni fuq il-pjan attwali ta’ dan il-workspace. Amministratur irid jattiva Pipedream Connect qabel ma xi ħadd jikkonnettja kont. L-awtorizzazzjonijiet eżistenti tal-kontijiet jinżammu.',
    connectionUnavailable:
      'Is-servizz tal-konnessjoni mhux disponibbli bħalissa. Erġa’ pprova aktar tard jew staqsi lil amministratur tal-workspace biex jiċċekkjah. L-awtorizzazzjonijiet eżistenti tal-kontijiet jinżammu.',
    readyMetaNoAccounts:
      'Meta huwa konness, iżda dan il-kont m’għandu l-ebda kont tar-reklami aċċessibbli. Staqsi lil amministratur ta’ Meta jagħtik aċċess għal kont tar-reklami, imbagħad erġa’ kkonnettja.',
    readyPermissions:
      'Meta huwa konness, iżda l-permessi meħtieġa għar-Reklami mhumiex disponibbli. Irrevedi l-permessi mitluba u erġa’ kkonnettja, jew staqsi lill-amministratur tal-workspace biex ilesti r-reviżjoni tal-app ta’ Meta.',
    readyAuth: 'Meta jeħtieġ li terġa’ tidħol qabel ma jkun jista’ jaqra d-dejta tar-Reklami.',
    readyRate:
      'Meta llimita temporanjament it-talbiet għal din il-konnessjoni. Erġa’ pprova aktar tard.',
    readyNoTools: 'Meta huwa konness, iżda ma pprovda l-ebda għodda għal dan il-kont.',
    readyToolsAuth:
      'Meta jeħtieġ li terġa’ tidħol qabel ma l-għodod tiegħu jkunu jistgħu jintużaw.',
    readyUnavailable:
      'L-għodod ta’ Meta mhumiex disponibbli temporanjament. Ipprova ċċekkja l-konnessjoni aktar tard.',
    readyCheck: 'Meta ma setax jiġi ċċekkjat bħalissa. Ipprova ċċekkja l-konnessjoni aktar tard.',
    readyEmpty: 'Meta huwa konness, iżda għad m’hemm l-ebda dejta aċċessibbli.',
    readyDefault:
      'Meta huwa konness, iżda ma setgħux jiġu ċċekkjati l-għodod disponibbli tiegħu. Erġa’ pprova aktar tard.',
    completed: '{name} huwa konness.',
    snapshotChanged: 'Din il-konverżazzjoni nbidlet. Aġġorna l-previżjoni qabel issalva.',
    snapshotTooLarge:
      'Din il-konverżazzjoni hija twila wisq għal kopja waħda. Staqsi lil Poneva biex isalva sommarju bħala Riżultat minflok.',
    snapshotEmpty: 'Għad m’hemm l-ebda messaġġ salvat x’taqsam.',
    snapshotGeneric: 'Ma stajniex inħejju din il-kopja. Jekk jogħġbok erġa’ pprova.',
  },
  pl: {
    statusConnected: 'Połączono',
    statusNotConnected: 'Nie połączono',
    statusNotConfigured: 'Jeszcze niedostępne',
    statusNeedsReauthorization: 'Wymaga ponownego logowania',
    statusUnavailable: 'Niedostępne',
    statusDisabled: 'Wyłączone',
    audienceEveryone: 'Wszyscy w {company}',
    audienceSelected: 'Wybrani współpracownicy',
    audienceOnlyMe: 'Tylko ja',
    companyPublish:
      'Możesz opublikować to w firmie. Wszyscy w organizacji będą mogli przeczytać ten element.',
    companyApproval:
      'Ta dokładna wersja zostanie przesłana do zatwierdzenia. Wszyscy uzyskają dostęp dopiero po jej zatwierdzeniu.',
    companyInstant: 'Wszyscy w {company} będą mogli to przeczytać od razu po zapisaniu.',
    connectionPlan:
      'Połączenia Pipedream nie mogą uruchamiać narzędzi w środowisku produkcyjnym w tym obszarze roboczym przy obecnym planie. Administrator musi włączyć Pipedream Connect, zanim ktokolwiek połączy konto. Istniejące autoryzacje kont zostaną zachowane.',
    connectionUnavailable:
      'Usługa połączeń jest obecnie niedostępna. Spróbuj ponownie później lub poproś administratora obszaru roboczego o sprawdzenie usługi. Istniejące autoryzacje kont zostaną zachowane.',
    readyMetaNoAccounts:
      'Meta jest połączona, ale to konto nie ma dostępnych kont reklamowych. Poproś administratora Meta o przyznanie dostępu do konta reklamowego, a następnie połącz ponownie.',
    readyPermissions:
      'Meta jest połączona, ale wymagane uprawnienia do reklam nie są dostępne. Sprawdź żądane uprawnienia i połącz ponownie lub poproś administratora obszaru roboczego o ukończenie procesu weryfikacji aplikacji Meta.',
    readyAuth: 'Meta wymaga ponownego zalogowania, zanim będzie można odczytać dane z reklam.',
    readyRate:
      'Meta tymczasowo ograniczyła liczbę żądań dla tego połączenia. Spróbuj ponownie później.',
    readyNoTools: 'Meta jest połączona, ale nie udostępniła żadnych narzędzi dla tego konta.',
    readyToolsAuth: 'Meta wymaga ponownego zalogowania, zanim będzie można używać jej narzędzi.',
    readyUnavailable:
      'Narzędzia Meta są tymczasowo niedostępne. Spróbuj ponownie sprawdzić połączenie później.',
    readyCheck:
      'Nie udało się teraz sprawdzić Meta. Spróbuj ponownie sprawdzić połączenie później.',
    readyEmpty: 'Meta jest połączona, ale nie ma jeszcze dostępnych danych.',
    readyDefault:
      'Meta jest połączona, ale nie udało się sprawdzić jej dostępnych narzędzi. Spróbuj ponownie później.',
    completed: 'Połączono {name}.',
    snapshotChanged: 'Ta rozmowa uległa zmianie. Odśwież podgląd przed zapisaniem.',
    snapshotTooLarge:
      'Ta rozmowa jest zbyt długa, aby utworzyć jedną kopię. Poproś Poneva o zapisanie podsumowania jako wyniku.',
    snapshotEmpty: 'Nie ma jeszcze żadnych zapisanych wiadomości do udostępnienia.',
    snapshotGeneric: 'Nie udało się przygotować tej kopii. Spróbuj ponownie.',
  },
  pt: {
    statusConnected: 'Conectado',
    statusNotConnected: 'Não conectado',
    statusNotConfigured: 'Ainda não disponível',
    statusNeedsReauthorization: 'É necessário iniciar sessão',
    statusUnavailable: 'Indisponível',
    statusDisabled: 'Desativado',
    audienceEveryone: 'Todos na {company}',
    audienceSelected: 'Colegas selecionados',
    audienceOnlyMe: 'Somente eu',
    companyPublish:
      'Você pode publicar para a empresa. Todos na organização poderão ler este item.',
    companyApproval:
      'Esta versão exata será enviada para aprovação. Todos terão acesso somente depois que ela for aprovada.',
    companyInstant: 'Todos na {company} poderão ler isto assim que você salvar.',
    connectionPlan:
      'As conexões do Pipedream não podem executar ferramentas em produção no plano atual deste workspace. Um administrador precisa ativar o Pipedream Connect antes que alguém conecte uma conta. As autorizações de contas existentes serão preservadas.',
    connectionUnavailable:
      'O serviço de conexão está indisponível no momento. Tente novamente mais tarde ou peça a um administrador do workspace para verificá-lo. As autorizações de contas existentes serão preservadas.',
    readyMetaNoAccounts:
      'O Meta está conectado, mas esta conta não tem contas de anúncios acessíveis. Peça a um administrador do Meta para conceder acesso a uma conta de anúncios e conecte novamente.',
    readyPermissions:
      'O Meta está conectado, mas as permissões necessárias para anúncios não estão disponíveis. Revise as permissões solicitadas e conecte novamente, ou peça ao administrador do workspace para concluir a análise do app Meta.',
    readyAuth:
      'O Meta precisa que você inicie sessão novamente antes que os dados de anúncios possam ser lidos.',
    readyRate:
      'O Meta limitou temporariamente as solicitações desta conexão. Tente novamente mais tarde.',
    readyNoTools: 'O Meta está conectado, mas não forneceu ferramentas para esta conta.',
    readyToolsAuth:
      'O Meta precisa que você inicie sessão novamente antes que suas ferramentas possam ser usadas.',
    readyUnavailable:
      'As ferramentas do Meta estão temporariamente indisponíveis. Tente verificar a conexão novamente mais tarde.',
    readyCheck:
      'Não foi possível verificar o Meta agora. Tente verificar a conexão novamente mais tarde.',
    readyEmpty: 'O Meta está conectado, mas ainda não há dados acessíveis.',
    readyDefault:
      'O Meta está conectado, mas não foi possível verificar as ferramentas disponíveis. Tente novamente mais tarde.',
    completed: '{name} está conectado.',
    snapshotChanged: 'Esta conversa mudou. Atualize a pré-visualização antes de salvar.',
    snapshotTooLarge:
      'Esta conversa é longa demais para uma única cópia. Peça ao Poneva para salvar um resumo como Resultado.',
    snapshotEmpty: 'Ainda não há mensagens salvas para compartilhar.',
    snapshotGeneric: 'Não foi possível preparar esta cópia. Tente novamente.',
  },
  ro: {
    statusConnected: 'Conectat',
    statusNotConnected: 'Neconectat',
    statusNotConfigured: 'Încă indisponibil',
    statusNeedsReauthorization: 'Necesită autentificare',
    statusUnavailable: 'Indisponibil',
    statusDisabled: 'Dezactivat',
    audienceEveryone: 'Toată lumea de la {company}',
    audienceSelected: 'Colegii selectați',
    audienceOnlyMe: 'Doar eu',
    companyPublish:
      'Poți publica pentru companie. Toată lumea din organizație va putea citi acest element.',
    companyApproval:
      'Această versiune exactă va fi trimisă spre aprobare. Toată lumea va primi acces doar după aprobare.',
    companyInstant: 'Toată lumea de la {company} va putea citi acest lucru imediat după salvare.',
    connectionPlan:
      'Conexiunile Pipedream nu pot rula instrumente în producție în acest spațiu de lucru, conform planului actual. Un administrator trebuie să activeze Pipedream Connect înainte ca cineva să conecteze un cont. Autorizațiile existente ale conturilor sunt păstrate.',
    connectionUnavailable:
      'Serviciul de conectare este indisponibil momentan. Încearcă din nou mai târziu sau roagă un administrator al spațiului de lucru să verifice. Autorizațiile existente ale conturilor sunt păstrate.',
    readyMetaNoAccounts:
      'Meta este conectat, dar acest cont nu are conturi de publicitate accesibile. Roagă un administrator Meta să acorde acces la un cont de publicitate, apoi reconectează-te.',
    readyPermissions:
      'Meta este conectat, dar permisiunile necesare pentru reclame nu sunt disponibile. Verifică permisiunile solicitate și reconectează-te sau roagă administratorul spațiului de lucru să finalizeze verificarea aplicației Meta.',
    readyAuth:
      'Meta îți solicită să te autentifici din nou înainte ca datele Ads să poată fi citite.',
    readyRate:
      'Meta a limitat temporar solicitările pentru această conexiune. Încearcă din nou mai târziu.',
    readyNoTools: 'Meta este conectat, dar nu a furnizat instrumente pentru acest cont.',
    readyToolsAuth:
      'Meta îți solicită să te autentifici din nou înainte ca instrumentele sale să poată fi utilizate.',
    readyUnavailable:
      'Instrumentele Meta sunt temporar indisponibile. Încearcă să verifici din nou conexiunea mai târziu.',
    readyCheck:
      'Meta nu a putut fi verificat momentan. Încearcă să verifici din nou conexiunea mai târziu.',
    readyEmpty: 'Meta este conectat, dar încă nu există date accesibile.',
    readyDefault:
      'Meta este conectat, dar instrumentele disponibile nu au putut fi verificate. Încearcă din nou mai târziu.',
    completed: '{name} este conectat.',
    snapshotChanged:
      'Această conversație s-a modificat. Reîmprospătează previzualizarea înainte de salvare.',
    snapshotTooLarge:
      'Această conversație este prea lungă pentru o singură copie. Roagă Poneva să salveze un rezumat ca rezultat.',
    snapshotEmpty: 'Încă nu există mesaje salvate de distribuit.',
    snapshotGeneric: 'Nu am putut pregăti această copie. Încearcă din nou.',
  },
  sk: {
    statusConnected: 'Pripojené',
    statusNotConnected: 'Nepripojené',
    statusNotConfigured: 'Zatiaľ nedostupné',
    statusNeedsReauthorization: 'Vyžaduje opätovné prihlásenie',
    statusUnavailable: 'Nedostupné',
    statusDisabled: 'Vypnuté',
    audienceEveryone: 'Všetci v organizácii {company}',
    audienceSelected: 'Vybraní kolegovia',
    audienceOnlyMe: 'Iba ja',
    companyPublish:
      'Túto položku môžete publikovať pre celú spoločnosť. Všetci v organizácii si ju budú môcť prečítať.',
    companyApproval:
      'Táto presná verzia bude odoslaná na schválenie. Všetci k nej získajú prístup až po jej schválení.',
    companyInstant: 'Všetci v organizácii {company} si to budú môcť prečítať hneď po uložení.',
    connectionPlan:
      'Pripojenia Pipedream nemôžu v tomto pracovnom priestore spúšťať nástroje v produkcii v rámci aktuálneho plánu. Správca musí povoliť Pipedream Connect, aby mohol ktokoľvek pripojiť účet. Existujúce autorizácie účtov zostanú zachované.',
    connectionUnavailable:
      'Služba pripojenia je momentálne nedostupná. Skúste to znova neskôr alebo požiadajte správcu pracovného priestoru, aby ju skontroloval. Existujúce autorizácie účtov zostanú zachované.',
    readyMetaNoAccounts:
      'Meta je pripojená, ale tento účet nemá prístup k žiadnym reklam accounts. Požiadajte správcu Meta o udelenie prístupu k reklamnému účtu a potom sa znova pripojte.',
    readyPermissions:
      'Meta je pripojená, ale požadované povolenia pre Ads nie sú k dispozícii. Skontrolujte požadované povolenia a znova sa pripojte alebo požiadajte správcu pracovného priestoru o dokončenie kontroly aplikácie Meta.',
    readyAuth: 'Meta vyžaduje, aby ste sa znova prihlásili, a až potom bude možné čítať údaje Ads.',
    readyRate: 'Meta dočasne obmedzila požiadavky pre toto pripojenie. Skúste to znova neskôr.',
    readyNoTools: 'Meta je pripojená, ale pre tento účet neposkytla žiadne nástroje.',
    readyToolsAuth:
      'Meta vyžaduje, aby ste sa znova prihlásili, a až potom bude možné používať jej nástroje.',
    readyUnavailable: 'Nástroje Meta sú dočasne nedostupné. Skúste pripojenie skontrolovať neskôr.',
    readyCheck: 'Meta sa momentálne nedala skontrolovať. Skúste pripojenie skontrolovať neskôr.',
    readyEmpty: 'Meta je pripojená, ale zatiaľ nie sú k dispozícii žiadne údaje.',
    readyDefault:
      'Meta je pripojená, ale dostupné nástroje sa nedali skontrolovať. Skúste to znova neskôr.',
    completed: '{name} je pripojené.',
    snapshotChanged: 'Táto konverzácia sa zmenila. Pred uložením obnovte ukážku.',
    snapshotTooLarge:
      'Táto konverzácia je príliš dlhá na jednu kópiu. Požiadajte Ponevu, aby uložila zhrnutie ako výsledok.',
    snapshotEmpty: 'Zatiaľ nie sú k dispozícii žiadne uložené správy na zdieľanie.',
    snapshotGeneric: 'Túto kópiu sa nepodarilo pripraviť. Skúste to znova.',
  },
  sl: {
    statusConnected: 'Povezano',
    statusNotConnected: 'Ni povezano',
    statusNotConfigured: 'Še ni na voljo',
    statusNeedsReauthorization: 'Potrebna je prijava',
    statusUnavailable: 'Ni na voljo',
    statusDisabled: 'Izklopljeno',
    audienceEveryone: 'Vsi v podjetju {company}',
    audienceSelected: 'Izbrani sodelavci',
    audienceOnlyMe: 'Samo jaz',
    companyPublish:
      'Objavite lahko za celotno podjetje. Vsi v organizaciji bodo lahko prebrali ta element.',
    companyApproval:
      'Ta natančna različica bo poslana v odobritev. Vsi bodo dobili dostop šele po odobritvi.',
    companyInstant: 'Vsi v podjetju {company} bodo to lahko prebrali takoj, ko shranite.',
    connectionPlan:
      'Povezave Pipedream v tem delovnem prostoru ne morejo izvajati orodij v produkciji glede na trenutni paket. Skrbnik mora omogočiti Pipedream Connect, preden lahko kdo poveže račun. Obstoječa pooblastila računov se ohranijo.',
    connectionUnavailable:
      'Storitev povezav trenutno ni na voljo. Poskusite znova pozneje ali prosite skrbnika delovnega prostora, naj to preveri. Obstoječa pooblastila računov se ohranijo.',
    readyMetaNoAccounts:
      'Meta je povezana, vendar ta račun nima dostopa do nobenega oglaševalskega računa. Prosite skrbnika Mete, naj vam omogoči dostop do oglaševalskega računa, nato pa se znova povežite.',
    readyPermissions:
      'Meta je povezana, vendar zahtevana dovoljenja za oglase niso na voljo. Preverite zahtevana dovoljenja in se znova povežite ali prosite skrbnika delovnega prostora, naj dokonča pregled aplikacije Meta.',
    readyAuth: 'Meta zahteva, da se znova prijavite, preden je mogoče prebrati podatke o oglasih.',
    readyRate: 'Meta je začasno omejila zahteve za to povezavo. Poskusite znova pozneje.',
    readyNoTools: 'Meta je povezana, vendar za ta račun ni zagotovila nobenih orodij.',
    readyToolsAuth: 'Meta zahteva, da se znova prijavite, preden lahko uporabite njena orodja.',
    readyUnavailable:
      'Orodja Meta trenutno niso na voljo. Poskusite povezavo preveriti znova pozneje.',
    readyCheck:
      'Povezave Meta trenutno ni bilo mogoče preveriti. Poskusite jo preveriti znova pozneje.',
    readyEmpty: 'Meta je povezana, vendar še ni na voljo nobenih dostopnih podatkov.',
    readyDefault:
      'Meta je povezana, vendar razpoložljivih orodij ni bilo mogoče preveriti. Poskusite znova pozneje.',
    completed: '{name} je povezan.',
    snapshotChanged: 'Ta pogovor se je spremenil. Pred shranjevanjem osvežite predogled.',
    snapshotTooLarge:
      'Ta pogovor je predolg za eno kopijo. Prosite Ponevo, naj povzetek shrani kot rezultat.',
    snapshotEmpty: 'Za deljenje še ni shranjenih sporočil.',
    snapshotGeneric: 'Te kopije ni bilo mogoče pripraviti. Poskusite znova.',
  },
  es: {
    statusConnected: 'Conectado',
    statusNotConnected: 'No conectado',
    statusNotConfigured: 'Aún no disponible',
    statusNeedsReauthorization: 'Requiere iniciar sesión',
    statusUnavailable: 'No disponible',
    statusDisabled: 'Desactivado',
    audienceEveryone: 'Todos en {company}',
    audienceSelected: 'Colegas seleccionados',
    audienceOnlyMe: 'Solo yo',
    companyPublish:
      'Puedes publicar para toda la empresa. Todas las personas de la organización podrán leer este elemento.',
    companyApproval:
      'Esta versión exacta se enviará para su aprobación. Todos obtendrán acceso cuando se apruebe.',
    companyInstant: 'Todos en {company} podrán leer esto en cuanto lo guardes.',
    connectionPlan:
      'Las conexiones de Pipedream no pueden ejecutar herramientas en producción con el plan actual de este espacio de trabajo. Un administrador debe habilitar Pipedream Connect antes de que alguien conecte una cuenta. Las autorizaciones de cuenta existentes se conservan.',
    connectionUnavailable:
      'El servicio de conexión no está disponible en este momento. Inténtalo de nuevo más tarde o pide a un administrador del espacio de trabajo que lo compruebe. Las autorizaciones de cuenta existentes se conservan.',
    readyMetaNoAccounts:
      'Meta está conectado, pero esta cuenta no tiene cuentas publicitarias accesibles. Pide a un administrador de Meta que conceda acceso a una cuenta publicitaria y vuelve a conectarla.',
    readyPermissions:
      'Meta está conectado, pero los permisos de anuncios necesarios no están disponibles. Revisa los permisos solicitados y vuelve a conectarlo, o pide al administrador del espacio de trabajo que complete la revisión de la aplicación de Meta.',
    readyAuth:
      'Meta necesita que vuelvas a iniciar sesión antes de poder leer sus datos de anuncios.',
    readyRate:
      'Meta ha limitado temporalmente las solicitudes de esta conexión. Inténtalo de nuevo más tarde.',
    readyNoTools: 'Meta está conectado, pero no proporcionó ninguna herramienta para esta cuenta.',
    readyToolsAuth:
      'Meta necesita que vuelvas a iniciar sesión antes de poder usar sus herramientas.',
    readyUnavailable:
      'Las herramientas de Meta no están disponibles temporalmente. Intenta comprobar la conexión de nuevo más tarde.',
    readyCheck:
      'No se pudo comprobar Meta en este momento. Intenta comprobar la conexión de nuevo más tarde.',
    readyEmpty: 'Meta está conectado, pero aún no hay datos accesibles.',
    readyDefault:
      'Meta está conectado, pero no se pudieron comprobar sus herramientas disponibles. Inténtalo de nuevo más tarde.',
    completed: '{name} está conectado.',
    snapshotChanged: 'Esta conversación cambió. Actualiza la vista previa antes de guardar.',
    snapshotTooLarge:
      'Esta conversación es demasiado larga para una sola copia. Pide a Poneva que guarde un resumen como resultado.',
    snapshotEmpty: 'Aún no hay mensajes guardados para compartir.',
    snapshotGeneric: 'No pudimos preparar esta copia. Inténtalo de nuevo.',
  },
  sv: {
    statusConnected: 'Ansluten',
    statusNotConnected: 'Inte ansluten',
    statusNotConfigured: 'Inte tillgänglig ännu',
    statusNeedsReauthorization: 'Kräver ny inloggning',
    statusUnavailable: 'Inte tillgänglig',
    statusDisabled: 'Avstängd',
    audienceEveryone: 'Alla på {company}',
    audienceSelected: 'Utvalda kollegor',
    audienceOnlyMe: 'Bara jag',
    companyPublish:
      'Du kan publicera för företaget. Alla i organisationen kommer att kunna läsa detta objekt.',
    companyApproval:
      'Den här exakta versionen skickas för godkännande. Alla får åtkomst först när den har godkänts.',
    companyInstant: 'Alla på {company} kan läsa detta så snart du sparar.',
    connectionPlan:
      'Pipedream-anslutningar kan inte köra verktyg i produktion med den här arbetsytans nuvarande abonnemang. En administratör måste aktivera Pipedream Connect innan någon ansluter ett konto. Befintliga kontoauktoriseringar bevaras.',
    connectionUnavailable:
      'Anslutningstjänsten är inte tillgänglig just nu. Försök igen senare eller be en arbetsyteadministratör att kontrollera den. Befintliga kontoauktoriseringar bevaras.',
    readyMetaNoAccounts:
      'Meta är anslutet, men det här kontot har inga åtkomliga annonskonton. Be en Meta-administratör att ge åtkomst till ett annonskonto och anslut sedan igen.',
    readyPermissions:
      'Meta är anslutet, men de nödvändiga annonsbehörigheterna är inte tillgängliga. Granska de begärda behörigheterna och anslut igen, eller be arbetsyteadministratören att slutföra granskningen av Meta-appen.',
    readyAuth: 'Meta kräver att du loggar in igen innan dess annonsdata kan läsas.',
    readyRate:
      'Meta har tillfälligt begränsat förfrågningar för den här anslutningen. Försök igen senare.',
    readyNoTools: 'Meta är anslutet, men tillhandahöll inga verktyg för det här kontot.',
    readyToolsAuth: 'Meta kräver att du loggar in igen innan dess verktyg kan användas.',
    readyUnavailable:
      'Metas verktyg är tillfälligt otillgängliga. Försök kontrollera anslutningen igen senare.',
    readyCheck:
      'Meta kunde inte kontrolleras just nu. Försök kontrollera anslutningen igen senare.',
    readyEmpty: 'Meta är anslutet, men det finns ännu inga åtkomliga data.',
    readyDefault:
      'Meta är anslutet, men de tillgängliga verktygen kunde inte kontrolleras. Försök igen senare.',
    completed: '{name} är ansluten.',
    snapshotChanged:
      'Den här konversationen har ändrats. Uppdatera förhandsvisningen innan du sparar.',
    snapshotTooLarge:
      'Den här konversationen är för lång för en enda kopia. Be Poneva att spara en sammanfattning som ett Resultat i stället.',
    snapshotEmpty: 'Det finns inga sparade meddelanden att dela ännu.',
    snapshotGeneric: 'Vi kunde inte förbereda den här kopian. Försök igen.',
  },
} as const;

export default sharingConnectorsCopy;
